var generator = require("generate-password");
export default {
  data() {
    return {
      USER_DIALOG_MIXIN_NAMESPACE: "",
      dialog: false,
      editMode: false,
      editModel: {},
      passVisible: true,
      questions: [
        "What is your favorite food?",
        "What is your Mother's maiden name?",
        "What was the name of the street where you grew up?"
      ],
      resetPassword: false,
      timeZones: [
        "Eastern Standard Time",
        "Atlantic Standard Time",
        "Central Standard Time",
        "Mountain Standard Time",
        "Pacific Standard Time",
        "Alaskan Standard Time",
        "Hawaiian Standard Time"
      ],
      userNameError: null,
      valid: false
    };
  },
  methods: {
    checkIfUserNameExists(v) {
      return this.$store
        .dispatch(`${this.USER_DIALOG_MIXIN_NAMESPACE}/checkUniqueUserName`, v)
        .then(response => {
          if (response.length > 0) {
            this.userNameError = "UserName must be unique";
          } else {
            this.userNameError = null;
          }
          return this.userNameError;
        });
    },
    setUsernameAsEmail() {
      this.editModel.UserName = this.editModel.Email;
      this.$forceUpdate();
    },
    validateUserName(v) {
      if (!v) return false;
      if (this.selectedUser.UserName !== v) this.checkIfUserNameExists(v);
      if (
        this.users.find(
          x =>
            x.UserName.toLowerCase() === (v + "").toLowerCase() &&
            x.Id !== this.editModel.Id
        )
      )
        return false;
      return true;
    }
  },
  watch: {
    resetPassword: /* istanbul ignore next */ function(val) {
      this.editModel.Password = generator.generate({
        length: 10,
        numbers: true,
        symbols: true,
        exclude: "<>"
      });
    },
    editModel: function(val) {
      if (val.ClientId) {
        var client = this.clients.find(x => {
          return x.Id === val.ClientId;
        });
        if (client) val.ClientName = client.Name;
      }
    }
  }
};
